// Single source of truth for supported countries, their timezones, and
// currency. Only the United States is enabled today — adding another
// country is a matter of appending one entry to SUPPORTED_COUNTRIES, not
// touching any consumer (admin dropdowns, backend validation, etc.).
export const SUPPORTED_COUNTRIES = [
    {
        code: 'US',
        name: 'United States',
        currency: 'USD',
        defaultTimezone: 'America/New_York',
        timezones: [
            { value: 'America/New_York', label: 'Eastern Time (New York)' },
            { value: 'America/Chicago', label: 'Central Time (Chicago)' },
            { value: 'America/Denver', label: 'Mountain Time (Denver)' },
            { value: 'America/Phoenix', label: 'Mountain Time - Arizona (Phoenix)' },
            { value: 'America/Los_Angeles', label: 'Pacific Time (Los Angeles)' },
            { value: 'America/Anchorage', label: 'Alaska Time (Anchorage)' },
            { value: 'America/Adak', label: 'Hawaii-Aleutian Time (Adak)' },
            { value: 'Pacific/Honolulu', label: 'Hawaii Time (Honolulu)' },
        ],
    },
];
export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_TIMEZONE = 'America/New_York';
export const DEFAULT_CURRENCY = 'USD';
//# sourceMappingURL=countries.js.map